export const defaultChainId = 97;

export const rpcUrls = {
  1337: 'http://localhost:8545',
  56: 'https://bsc-dataseed1.binance.org',
  97: 'https://data-seed-prebsc-1-s1.binance.org:8545',
  1: 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161/',
}

export const networkNames = {
  // 1: 'Ethereum Mainnet',
  1337: 'Localhost8545',
  56: 'BSC Main Network',
  97: 'BSC Test Network',
  1: 'Ethereum Mainnet'
}

export const addresses = {
  coinracerNFT: {
    97: '0x8070c987d80B1363710BF53998C9078ebD75A05B',
    56: '0x1B967351e96Bc52E7f4c28EB97406bfa7eB8c8b2'
  },
  coinracerToken: {
    97: '0xe9852a19b7E15993d99a51099eb3f8DAC4f51997',
    56: '0xfbb4f2f342c6daab63ab85b0226716c4d1e26f36'
  },
  busdToken: {
    97: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee',
    56: '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56'
  },
  coinracerMarketPlace: {
    56: '0x2C8206b4adcef3D29869433bA5Fc5d1203bee53e',
    97: '0xe2327744153387d53e29772b32B9d862d0Ab5baa' //change
  },
  toxic: {
    97: '0xFeCdcC75b40bFbD62E7fEdF3F4CBc235f1D01bd6',
    56: '0xc49EE24dd68b58280E9737dBBb3aa0687c28A237'
  },
  mutant: {
    97: '0x4d548AEdf1B1647464033864A2E306dE40354859',
    56: '0x962755fEB721B2e716C3E996e20900d9bD3b5372'
  },
  coinracerNFTOld: {
    97: '0xD20086Ff85bc773f54d16Abce2e5bA0dD616B395',
    56: '0x3A7951Ff955d4e0b6CBBe54De8593606e5e0FA08'
  },
  stakingv2: {
    97: '0x42DdA1a6D86a252C65eBcb46236c69a87b7ECA08',
    56: '0xE13b48B35AF97B1669135f400eAe3Abb8Eb6A562'
  },
  swap:{
    97: '0x79c9eC90DC2eBe3427aBf8d14E2cE2d33CC57E58',
    56: '0x79c9eC90DC2eBe3427aBf8d14E2cE2d33CC57E58'
  }
}

export const mutantURIs = {
  "https://ipfs.io/ipfs/bafybeiaf76xccetqrbgnaivfmmxaluwe6xiqxniv75y7ehtme4dpd2rmim/Malibu_Box.gif" : "https://ipfs.io/ipfs/QmZiRwz1bQCpSps3FUPAmDb4NZnWoYsefGigy6mPhBLpYE", //malibu
  "https://ipfs.io/ipfs/bafybeid5aeqpm3xt6yiwpuuajfseeoam27yn6lu45oxgc2ixhjojdmjgqe/CoinracerGT_Box.gif" : "https://ipfs.io/ipfs/QmUARJL7T7h3Tc3LgxbU2E5qFhHXyULrpQnZP2EVnK9fND", //coinracergt
  "https://ipfs.io/ipfs/bafybeibjbipf4eehesarcmqdwwwvo3wq5lqnbcikk4zw66a3rrtn7rtqgm/Nightcrawler_Box.gif" : "https://ipfs.io/ipfs/QmVAYUaWE2C6bUZDD4N3ot8phyQgESRj3zxxo4ickNhPMJ", //nightcrawler
  "https://ipfs.io/ipfs/bafybeienjaiz6ybp5c5xwb3u2g4tkhg3ad4l5pkwumiwj43ngcxcnv3rwu/Coinrrari_Box.gif" : "https://ipfs.io/ipfs/QmcQLNTucRGbRAcscRkojfhc44FvYwGgnmJ31wCkELsx9U", //coinrarri
  "https://ipfs.io/ipfs/bafybeia6zzupu5rvgzijlalperutoyg3iyfxaq6hm3z2ligo556yktdpze/CyberCar_Box.gif" : "https://ipfs.io/ipfs/QmcocxuwhmhZMSvXibRbbtbjHozjnjhN4KshLidigPoSGe", //cyber
  "https://ipfs.io/ipfs/bafybeicz2vtlu7ej5si7seb345unlu7wfrne2ld4lbyf3g3lchr77o4ui4/Merky_Box.gif" : "https://ipfs.io/ipfs/QmWc48cBXYL9iuEoXGKF6zx2MAR9RFibrTAZNycZKUiexY", //merky
  "https://ipfs.io/ipfs/bafybeiaivc6lf7kbyykuxw24yloc3hbae2zv2mubjahfbgidafjqwi62h4/Bonecrusher_Box.gif" : "https://ipfs.io/ipfs/QmWQ1uApCBnm5cjJbEa8ojBoQPgUNhyqjBd3hKNeF7GcCf", //bonecrusher
  "https://ipfs.io/ipfs/QmZ1X3REmPM7tyZHts1PBso3QLrHamfe5VvF5TqFhdehvK" : "https://ipfs.io/ipfs/Qmc5z6Lrmc6tsgBwQmU4cbiZkunhV2SYo3ZK7SP6zu5aQw", //telecoin
  "https://ipfs.io/ipfs/QmTV1naEXYnwpxwqtzrmKrr5RrDpKVBmHVmpEQgBQBE7e6" : "https://ipfs.io/ipfs/QmRAGjX9UBRPiZZwNBN42PyGy1wZCtiMgTKbFLJ2mnZ2nj", //lambo
  "https://ipfs.io/ipfs/QmcAoECUaMsk5GQMdUauFgW13yECnLh1EywkgvYV4XVniA" : "https://ipfs.io/ipfs/QmdbQAiAsDM8NGqv9VQ9tHbWJmZswF85dbCiyxeKiqJCAD", //lucky bus
  "https://ipfs.io/ipfs/QmSwXe4Znek9mhJ8YeyaVmVzpuQ8FdZR9818jAvc86kfFV" : "https://ipfs.io/ipfs/QmbRrZKeqbNc9XucgBmuDCjUFQtfMZ9xhtaSxBGKPaJiSn", //hovercar
  "https://ipfs.io/ipfs/QmWbpDUcKCbfnZAnqknATWKG3JaXWdAKUnGa1dVKnfvNK5" : "https://ipfs.io/ipfs/Qmaeses1JKoovRVLx2aBA8CoFkHztUij7dVFrCjq2WuxR4" //black ace

}

// staging
export const swapBO = {
   apiBaseURL: "https://a5bpvdxkckbp.usemoralis.com:2053/server/functions/",
   ApplicationId: "8QhdEDdOy6fgMp0Bu6bUXmCU91VSvF1SDJOXbZAQ"
}

// Live
// export const swapBO = {
//   apiBaseURL: "https://a5bpvdxkckbp.usemoralis.com:2053/server/functions/",
//   ApplicationId: "pKuKK6HrgqyanNOQy4dygy0JdHEvQ8h5HFUAdN9v"
// }


export const decimal = 8;
